import { memo } from "react";
import ChartEngine from "@/components/ChartEngine";
import { TIMEFRAMES } from "./utils";

const IndexChart = memo(({ symbol, exchange, liveTick, chartType, setChartType, tf, setTf, onPeriodChange, onOpenTerminal, tvSymbol }) => {
  return (
    <div data-testid="index-chart-container">
      <ChartEngine
        symbol={symbol}
        timeframe={tf}
        exchange={exchange}
        chartType={chartType}
        currentPrice={liveTick?.last_price}
        priceChange={liveTick?.change}
        changePercent={liveTick?.change_percent}
        liveTick={liveTick}
        height={800}
        onPeriodChange={onPeriodChange}
      />
      {/* Timeframe footer — matches ChartCard.js: timeframes + candle toggle + Terminal (right-aligned) */}
      <div className="flex items-center gap-1 mt-2">
        {TIMEFRAMES.map((t) => (
          <button
            key={t}
            onClick={() => setTf(t)}
            className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-colors ${
              tf === t ? "bg-gray-900 text-white" : "text-gray-500 hover:bg-gray-100"
            }`}
            data-testid={`tf-${t}`}
          >{t}</button>
        ))}
        {/* Candle toggle */}
        <button
          onClick={() => setChartType(chartType === "line" ? "candlestick" : "line")}
          className={`ml-1 p-1.5 rounded-md transition-colors ${
            chartType === "candlestick" ? "bg-gray-100" : "hover:bg-gray-100"
          }`}
          title={chartType === "line" ? "Switch to candles" : "Switch to line"}
          data-testid="chart-type-toggle"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-gray-600">
            <line x1="9" y1="4" x2="9" y2="20" /><rect x="6" y="8" width="6" height="8" rx="1" fill={chartType === "candlestick" ? "currentColor" : "none"} />
            <line x1="17" y1="2" x2="17" y2="22" /><rect x="14" y="6" width="6" height="10" rx="1" fill={chartType === "candlestick" ? "currentColor" : "none"} />
          </svg>
        </button>
        {/* Terminal — bottom-right of chart row (Groww parity) */}
        {tvSymbol ? (
          <a
            href={`https://www.tradingview.com/chart/?symbol=${encodeURIComponent(tvSymbol)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 px-3 py-1.5 border border-gray-200 rounded-md text-xs font-semibold text-gray-600 hover:border-gray-300 hover:bg-gray-50 transition-all ml-auto"
            title="Open Advanced Chart Terminal"
            data-testid="terminal-btn"
          >
            Terminal
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
              <path d="M15 3h6v6"/>
              <path d="M10 14L21 3"/>
            </svg>
          </a>
        ) : (
          <button
            onClick={onOpenTerminal}
            className="flex items-center gap-1.5 px-3 py-1.5 border border-gray-200 rounded-md text-xs font-semibold text-gray-600 hover:border-gray-300 hover:bg-gray-50 transition-all ml-auto"
            title="Open Terminal"
            data-testid="terminal-btn"
          >
            Terminal
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
              <path d="M15 3h6v6"/>
              <path d="M10 14L21 3"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
});

export default IndexChart;
